import { Popover } from 'bootstrap';

export default class TokenToggle {

  constructor() {
    this.toggles = document.querySelectorAll('.token-toggle');
    const self = this;

    if ( this.toggles.length ) {
      this.toggles.forEach(toggle => {
        const visibilityButton = toggle.querySelector('.toggle-token-visibility');
        visibilityButton.addEventListener('click', self.toggleTokenVisibility.bind(this, visibilityButton));

        const copyButton = toggle.querySelector('.toggle-token-copy');

        const popover  = new Popover(copyButton, {
          container: copyButton.closest('.token-toggle'),
          content: 'Copied!',
          placement: 'bottom',
        })

        copyButton.addEventListener('click', () => {
          popover.show()
          self.copyToClipboard(copyButton.dataset.value)
          setTimeout(() => {
            popover.hide()
          }, 2000);
        })
      });
    }
  }

  copyToClipboard(value) {
		const elem = document.createElement('textarea')
		elem.value = value
		elem.select()
		elem.setSelectionRange(0, 99999) /* For mobile devices */
		navigator.clipboard.writeText(elem.value)
  }

  toggleTokenVisibility(button) {
    const parent = button.closest('.token-toggle');
    const tokenContainer = parent.querySelector('span');

    const icon = button.querySelector('i');
    icon.classList.toggle('fa-eye');
    icon.classList.toggle('fa-eye-slash');

    if (icon.classList.contains('fa-eye-slash')) {
      tokenContainer.innerText = tokenContainer.dataset.token;
    } else {
      const hiddenToken = '&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;'
      tokenContainer.innerHTML = hiddenToken
    }
  }
}
